import {Field} from "formik";
import React from "react";

export default function CampoInputTesto({
                                            elemento,
                                            modifica,
                                            valore,
                                            disabled,
                                            fieldRef,
                                            onBlurCampo,
                                            onFocusCampo,
                                            onChangeCampo,
                                            onValidate,
                                        }) {

    return (
        <Field
            name={elemento.cella}
            id={elemento.id_kpi_elemento}
            className={"sost-input-tabella-kpi" + (modifica === true ? ' sost-input-tabella-kpi--mod' : '')}
            value={valore}
            placeholder={elemento.placeholder}
            disabled={disabled}
            innerRef={fieldRef}
            onFocus={onFocusCampo}
            onChange={onChangeCampo}
            onBlur={onBlurCampo}
            validate={onValidate}
        />
    );
}